import { createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-1 pb-1 flex flex-wrap gap-1 mr-1" }
const _hoisted_2 = { class: "p-1 w-10" }
const _hoisted_3 = {
  key: 0,
  class: "thumbnail-container flex align-items-center justify-content-center h-8rem border-solid border-1 surface-border border-round-sm"
}
const _hoisted_4 = ["src", "onClick"]
const _hoisted_5 = {
  key: 1,
  class: "w-full h-8rem flex align-items-center justify-content-center border-solid border-1 surface-border border-round-sm"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-ban text-6xl font-light text-500" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "w-10rem text-500 text-sm font-medium overflow-hidden text-overflow-ellipsis" }
const _hoisted_9 = { class: "text-400 text-xs" }
const _hoisted_10 = { class: "p-1 w-2" }
const _hoisted_11 = { class: "download p-1 align-items-center justify-content-center flex" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "p-1 align-items-center justify-content-center flex" }
const _hoisted_14 = { class: "modal-content" }
const _hoisted_15 = { class: "p-1 align-items-center justify-content-center flex" }
const _hoisted_16 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_Card = _resolveComponent("Card")!

  return ($data.store.attachments.length > 0)
    ? (_openBlock(), _createBlock(_component_Card, {
        key: 0,
        class: "w-9 ml-2 shadow-2"
      }, {
        title: _withCtx(() => [
          _createTextVNode("Existujúce prílohy")
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.store.attachments, (att) => {
              return (_openBlock(), _createElementBlock("div", {
                key: att.id,
                class: "shadow-2 p-1 flex surface-card w-13rem",
                style: {"border-radius":"6px"}
              }, [
                _createElementVNode("div", _hoisted_2, [
                  (att.thumbnail)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("img", {
                          src: $options.thumbnailUrl(att),
                          alt: "Thumbnail",
                          class: "w-full h-full border-round-sm cursor-pointer",
                          onClick: ($event: any) => ($options.openModal(att))
                        }, null, 8, _hoisted_4)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(att.name + "." + att.fileExt), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString($options.formattedFileSize(att.size)), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("a", {
                      href: $data.store.Api_url + '/download/' + att.id 
                    }, [
                      _createVNode(_component_PrimevueButton, {
                        icon: "pi pi-download",
                        severity: "secondary",
                        "aria-label": "Download"
                      })
                    ], 8, _hoisted_12)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_PrimevueButton, {
                        onClick: ($event: any) => ($options.onRemoveFile(att.id)),
                        class: "file-danger",
                        icon: "pi pi-times",
                        severity: "danger",
                        "aria-label": "Delete"
                      }, null, 8, ["onClick"])
                    ])
                  ])
                ])
              ]))
            }), 128)),
            ($data.showModal)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "modal-overlay",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => ($options.closeModal && $options.closeModal(...args)), ["self"]))
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("img", {
                        src: $data.modalImage,
                        alt: "Full Image",
                        class: "modal-image"
                      }, null, 8, _hoisted_16)
                    ]),
                    _createElementVNode("button", {
                      class: "modal-close-btn",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.closeModal && $options.closeModal(...args)))
                    }, "X")
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}